import React from 'react';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { TextLoading } from '../CommonComponents/OPL/Text/Text.loading';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Grid } from '../CommonComponents/OPL/Grid/Grid';
import { Row } from '../CommonComponents/OPL/Grid/Row';
import { Column } from '../CommonComponents/OPL/Grid/Column';

export const PaymentLoading: React.FC = () => {
  return (
    <ModalBody>
      <Box mb="32">
        <TextLoading width="50%" height="h2" />
      </Box>

      <Box mb="16">
        <TextLoading width={100} height="body" />
        <TextLoading width="100%" height="h1" />
      </Box>

      <Box mb="16">
        <Grid>
          <Row>
            <Column width={6}>
              <TextLoading width={100} height="body" />
              <TextLoading width="100%" height="h1" />
            </Column>

            <Column width={6}>
              <TextLoading width={100} height="body" />
              <TextLoading width="100%" height="h1" />
            </Column>
          </Row>
        </Grid>
      </Box>
    </ModalBody>
  );
};
